export const PERSON = {
    DATA_RECEIVED: "PERSON_DATA_RECEIVED",
    FRIENDS_RECEIVED: "PERSON_FRIENDS_RECEIVED",
    DATA_RESET: "PERSON_DATA_RESET",
    FRIENDS_RESET: "PERSON_FRIENDS_RESET",
};
